import { Address } from "@origin-digital/address-lookup";
import { AddressProp } from "../screens/UpdateAddress";
import { ContactPreferenceProp } from "../screens/UpdateContactPrefsScreen/ContactOption";
import { BusinessDetailsProp } from "../screens/Manage/BusinessDetail";
import { ProfileFieldMapTypes } from "./profileFieldMapContextHelpers";

export enum FieldType {
  NAME = "NAME",
  DOB = "DOB",
  EMAIL = "EMAIL",
  MOBILE = "MOBILE",
  LANDLINE = "LANDLINE",
  HOME_PHONE = "HOME_PHONE",
  BILLING_ADDRESS = "BILLING_ADDRESS",
  CONTACT_PREFERENCE = "CONTACT_PREFERENCE",
  BUSINESS_ACCOUNT = "BUSINESS_ACCOUNT",
}

export type FieldUnsupported = null;
export type FieldUpdateHookUnsupported = null;
export type FieldUpdateHook<T> = () => [
  (value: T) => void,
  {
    success: boolean | undefined;
    loading: boolean;
    error: Error | undefined;
    data?: T;
  }
];

export type ProfileFieldMap = {
  [FieldType.NAME]:
    | {
        data: string | null;
        useUpdate: FieldUpdateHook<string> | FieldUpdateHookUnsupported;
        editable: boolean;
      }
    | FieldUnsupported;
  [FieldType.DOB]:
    | {
        data: string | null;
        useUpdate: FieldUpdateHook<string> | FieldUpdateHookUnsupported;
        editable: boolean;
      }
    | FieldUnsupported;
  [FieldType.EMAIL]:
    | {
        data: string | null;
        useUpdate: FieldUpdateHook<string> | FieldUpdateHookUnsupported;
        editable: boolean;
      }
    | FieldUnsupported;
  [FieldType.MOBILE]:
    | {
        data: string | null;
        useUpdate: FieldUpdateHook<string> | FieldUpdateHookUnsupported;
        editable: boolean;
      }
    | FieldUnsupported;
  [FieldType.LANDLINE]:
    | {
        data: string | null;
        useUpdate: FieldUpdateHook<string> | FieldUpdateHookUnsupported;
        editable: boolean;
      }
    | FieldUnsupported;
  [FieldType.HOME_PHONE]:
    | {
        data: string | null;
        useUpdate: FieldUpdateHook<string> | FieldUpdateHookUnsupported;
        editable: boolean;
      }
    | FieldUnsupported;
  [FieldType.BILLING_ADDRESS]:
    | {
        data: AddressProp[];
        useUpdate: FieldUpdateHook<Address> | FieldUpdateHookUnsupported;
        editable: boolean;
      }
    | FieldUnsupported;
  [FieldType.CONTACT_PREFERENCE]:
    | {
        data: ContactPreferenceProp[];
        useUpdate:
          | FieldUpdateHook<ContactPreferenceProp>
          | FieldUpdateHookUnsupported;
        editable: boolean;
      }
    | FieldUnsupported;
  [FieldType.BUSINESS_ACCOUNT]:
    | {
        data: BusinessDetailsProp;
      }
    | FieldUnsupported;
};

export type ContactPreferenceRefetchFieldFunction = (
  type: ProfileFieldMapTypes
) => void;

export type RefetchFieldFunction = () => void;

export type ProfileFieldMapResult = {
  fieldMap?: ProfileFieldMap;
  refetch: RefetchFieldFunction | ContactPreferenceRefetchFieldFunction;
  loading: boolean;
  error: Error | undefined;
};
export type ProfileFieldMapHook = () => ProfileFieldMapResult;

export const FIELD_UNSUPPORTED: FieldUnsupported = null;
export const PROFILE_FIELD_MAP_RESULT_UNSUPPORTED: ProfileFieldMapHook =
  () => ({
    fieldMap: {
      [FieldType.NAME]: FIELD_UNSUPPORTED,
      [FieldType.DOB]: FIELD_UNSUPPORTED,
      [FieldType.EMAIL]: FIELD_UNSUPPORTED,
      [FieldType.MOBILE]: FIELD_UNSUPPORTED,
      [FieldType.LANDLINE]: FIELD_UNSUPPORTED,
      [FieldType.HOME_PHONE]: FIELD_UNSUPPORTED,
      [FieldType.BILLING_ADDRESS]: FIELD_UNSUPPORTED,
      [FieldType.CONTACT_PREFERENCE]: FIELD_UNSUPPORTED,
      [FieldType.BUSINESS_ACCOUNT]: FIELD_UNSUPPORTED,
    },
    refetch: () => {},
    loading: false,
    error: undefined,
  });
export const FIELD_UPDATE_HOOK_UNSUPPORTED: FieldUpdateHookUnsupported = null;
